/**
 * Высота текста при заданной ширине колонки: нужна ag-grid, чтобы посчитать высоту строки
 * до отрисовки. Меряем скрытым элементом — по-другому браузер размер не отдаёт.
 */
export function calculateTextHeight(text: string, width: number, lineHeight: number): number {
  const tempElement = document.createElement("div")

  tempElement.style.position = "absolute"
  tempElement.style.visibility = "hidden"
  tempElement.style.width = `${width}px`
  tempElement.style.lineHeight = `${lineHeight}px`
  tempElement.style.whiteSpace = "normal"
  tempElement.style.wordWrap = "break-word"
  tempElement.textContent = text

  document.body.appendChild(tempElement)

  const height = tempElement.clientHeight

  document.body.removeChild(tempElement)

  return height
}
